import React from 'react';

export const Privacy = () => {
  return (
    <div className="min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-5 md:px-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="heading-1 text-text-primary mb-6">PRIVACY POLICY</h1>
          <p className="body-small text-text-secondary mb-12">Last updated: {new Date().toLocaleDateString()}</p>

          <div className="space-y-8">
            <section>
              <h2 className="heading-4 text-text-primary mb-4">1. Introduction</h2>
              <p className="body-medium text-text-secondary mb-4">
                Opti Flo Apps Ltd ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you visit our website or use our products.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">2. Information We Collect</h2>
              <p className="body-medium text-text-secondary mb-4">
                We may collect and process the following types of information:
              </p>
              <ul className="space-y-2 ml-6">
                <li className="body-medium text-text-secondary">• Personal identification information (name, email address, phone number)</li>
                <li className="body-medium text-text-secondary">• Technical data (IP address, browser type, operating system)</li>
                <li className="body-medium text-text-secondary">• Usage data (how you interact with our services)</li>
                <li className="body-medium text-text-secondary">• Marketing and communications preferences</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">3. How We Use Your Information</h2>
              <p className="body-medium text-text-secondary mb-4">
                We use your information for the following purposes:
              </p>
              <ul className="space-y-2 ml-6">
                <li className="body-medium text-text-secondary">• To provide and maintain our services</li>
                <li className="body-medium text-text-secondary">• To notify you about changes to our services</li>
                <li className="body-medium text-text-secondary">• To provide customer support</li>
                <li className="body-medium text-text-secondary">• To gather analysis or valuable information to improve our services</li>
                <li className="body-medium text-text-secondary">• To detect, prevent and address technical issues</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">4. Data Security</h2>
              <p className="body-medium text-text-secondary mb-4">
                We implement appropriate technical and organizational measures to protect your personal data against unauthorized or unlawful processing, accidental loss, destruction, or damage.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">5. Third-Party Services</h2>
              <p className="body-medium text-text-secondary mb-4">
                We may employ third-party companies and individuals to facilitate our services, provide services on our behalf, or assist us in analyzing how our services are used. These third parties have access to your personal data only to perform specific tasks on our behalf and are obligated not to disclose or use it for any other purpose.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">6. Your Rights</h2>
              <p className="body-medium text-text-secondary mb-4">
                Depending on your location, you may have the following rights:
              </p>
              <ul className="space-y-2 ml-6">
                <li className="body-medium text-text-secondary">• The right to access your personal data</li>
                <li className="body-medium text-text-secondary">• The right to rectification of inaccurate data</li>
                <li className="body-medium text-text-secondary">• The right to erasure of your data</li>
                <li className="body-medium text-text-secondary">• The right to restrict processing</li>
                <li className="body-medium text-text-secondary">• The right to data portability</li>
                <li className="body-medium text-text-secondary">• The right to object to processing</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">7. Changes to This Privacy Policy</h2>
              <p className="body-medium text-text-secondary mb-4">
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">8. Contact Us</h2>
              <p className="body-medium text-text-secondary mb-4">
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <p className="body-medium text-text-primary">
                Email: <a href="mailto:contact@optiflo.app" className="text-brand-primary hover:underline">contact@optiflo.app</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};